import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { ParsedOperon } from 'stores/models/types';

interface IProps {
  model?: ParsedOperon | null;
  prediction?: boolean;
}

const NONE = 'None';

class View extends Component<IProps> {
  render() {
    const { model, prediction } = this.props;
    const hasPrediction = !!model && typeof prediction === 'boolean';
    const predictionLabel = prediction ? 'Correct' : 'Incorrect';

    return (
      <p>
        Prediction:{' '}
        <span className='has-text-weight-semibold'>
          {hasPrediction ? predictionLabel : NONE}
        </span>
      </p>
    );
  }
}

const PredictionResult = observer(View);
export default PredictionResult;
